import React, { useEffect } from 'react';
import { useMemo } from 'react';

function SelectInput(_ref) {
  var showOptionList = _ref.showOptionList,
      name = _ref.name,
      isSearchable = _ref.isSearchable,
      disabled = _ref.disabled,
      filterResults = _ref.filterResults,
      handleListDisplay = _ref.handleListDisplay,
      classes = _ref.classes,
      value = _ref.value,
      id = _ref.id,
      placeholder = _ref.placeholder,
      label = _ref.label,
      error = _ref.error,
      options = _ref.options,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? 'light' : _ref$mode,
      isTwoDimensional = _ref.isTwoDimensional,
      setFocusSearch = _ref.setFocusSearch,
      focusSearch = _ref.focusSearch;

  var filter = function filter(options) {
    var filteredItem;
    options === null || options === void 0 ? void 0 : options.find(function (option) {
      if (isTwoDimensional && (option === null || option === void 0 ? void 0 : option.code) === value) filteredItem = option;else if ((option === null || option === void 0 ? void 0 : option.value) === value) filteredItem = option;
    });
    return filteredItem;
  };

  var selectedValue = useMemo(function () {
    return value !== null && value !== void 0 && value.value ? value : filter(options);
  }, [value, options]);
  useEffect(function () {
    return ((value === null || value === void 0 ? void 0 : value.value) || value) && setFocusSearch(false);
  }, [value]);
  var inputClasses = classes['selected-text'];
  var labelClasses;

  if (mode === 'dark') {
    inputClasses = classes['selected-text_dark'];
    labelClasses = classes['label_dark'];
  }

  return React.createElement(React.Fragment, null, label ? React.createElement("span", {
    className: value || error || focusSearch ? classes.focus : classes.placeholder
  }, placeholder) : null, React.createElement("div", {
    className: "".concat(inputClasses, "} \n                 ").concat(error && !value ? 'border-error' : '', "\n                        ").concat(showOptionList === name ? "".concat(classes.active) : ''),
    style: {
      opacity: disabled ? 0.8 : 1
    },
    onClick: function onClick(e) {
      setFocusSearch(true);
      handleListDisplay(e);
      if (isSearchable) setTimeout(function () {
        return document.getElementById('select-input').focus();
      }, 0);
    }
  }, isSearchable && focusSearch ? React.createElement("input", {
    type: "text",
    autoComplete: "off",
    id: "select-input",
    className: classes.searchInput,
    onChange: filterResults,
    disabled: disabled,
    onBlur: function onBlur(e) {
      if (value !== null && value !== void 0 && value.label && e.target.value !== (value === null || value === void 0 ? void 0 : value.label)) e.target.value = value === null || value === void 0 ? void 0 : value.label;
      setFocusSearch(false);
    },
    role: "combobox",
    "aria-autocomplete": "list",
    "aria-expanded": true,
    "aria-owns": "select-dropdown",
    "aria-controls": "select-dropdown"
  }) : React.createElement(React.Fragment, null, React.createElement("p", {
    style: {
      height: '20px'
    },
    className: labelClasses
  }, selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.label), React.createElement("input", {
    type: "text",
    className: classes.hiddenInput,
    id: id || 'hidden-input',
    onFocus: function onFocus(e) {
      handleListDisplay(e);

      if (isSearchable) {
        setFocusSearch(true);
        setTimeout(function () {
          var _document$getElementB;

          return (_document$getElementB = document.getElementById('select-input')) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.focus();
        }, 0);
      }
    },
    value: (selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.label) || ''
  })), React.createElement("div", {
    className: "".concat(classes.arrow, " custom-select-arrow")
  })));
}

export default SelectInput;